import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { urls, currentLang, currentPath } from "./links";

/**
 * Move the address bar to a page's canonical URL once it is known (old slug,
 * other spelling of a city, old section name). The server already redirects
 * these with a 301; this covers client-side navigation and old in-app links.
 *
 * canonical: decoded path, optionally with "?page=N". Falsy = not known yet.
 */
export default function useCanonical(canonical) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!canonical) return;
    const [path, query] = canonical.split("?");
    const here = currentPath(location.pathname);
    const sameQuery = query === undefined || location.search === "?" + query;
    if (urls.parsePath(path).lang !== currentLang()) {
      // Another language (e.g. a French question opened from the Arabic
      // list): reload so i18n, <html dir> and the stylesheet follow the URL.
      window.location.replace(urls.toHref(canonical));
    } else if (here !== currentPath(path) || !sameQuery) {
      // Keep the history state (the name search travels in it).
      navigate(canonical, { replace: true, state: location.state });
    }
  }, [canonical, location.pathname, location.search, location.state, navigate]);
}
